var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnsNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "607nplf4qa",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    id: "b6lsr9m0zc",
    d: "M0 0L50 0 50 50 0 50z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-188 -606) translate(188 606)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6a0syx2bpb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#607nplf4qa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#607nplf4qa"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#6a0syx2bpb)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mtihdp7x3d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6lsr9m0zc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1EC800",
    d: "M50 45.688C50 48.06 48.064 50 45.69 50H4.311C1.94 50 0 48.06 0 45.688V4.31C0 1.939 1.94 0 4.311 0H45.69C48.064 0 50 1.938 50 4.31v41.378z",
    mask: "url(#mtihdp7x3d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.277 17.045L28.277 24.499 22.878 17.045 17.045 17.045 17.045 31.818 22.86 31.818 22.86 24.365 28.258 31.818 34.091 31.818 34.091 17.045z",
    mask: "url(#mtihdp7x3d)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsNaver);
export default __webpack_public_path__ + "static/media/sns_naver.b9c5371d7f9290cf5e66266193cf94b8.svg";
export { ForwardRef as ReactComponent };